var render = function render(){var _vm=this,_c=_vm._self._c;return _c('node',{attrs:{"title":"发起人","is-root":true,"content":_vm.content,"placeholder":"所有人","header-icon":"el-icon-user-solid","header-bgc":"#067b50"},on:{"selected":function($event){return _vm.$emit('selected')},"insertNode":type => _vm.$emit('insertNode', type)}})
}
var staticRenderFns = []

export { render, staticRenderFns }